// functions/home_page_fire_register_functions.js

import { v4 as uuidv4 } from 'uuid';

// Import query routes
import { fetch_todays_register, add_register_entry, update_register_entry } from "../../api/register";

export class HomePageFireRegister {
    constructor(showAlert) {
        this.showAlert = showAlert;
    }

    fetchFireRegisterData = async (setFireRegisterData) => {
        try {
            const { data, status } = await fetch_todays_register();
            if (status === 200) {
                setFireRegisterData(data.data || []);
            } else {
                setFireRegisterData([]);
                this.showAlert({
                    message: 'Failed to fetch fire register data.',
                    type: 'danger',
                    buttons: [{ type: 'danger', label: 'Close' }],
                });
            }
        } catch (error) {
            setFireRegisterData([]);
            this.showAlert({
                message: 'An error occurred while fetching fire register data.',
                type: 'danger',
                buttons: [{ type: 'danger', label: 'Close' }],
            });
        } finally {
            console.log('Fetch fire register data completed.');
        }
    }

    handleSignIn = async (name, surname, company, timeIn, profileId, fetchFireRegisterData) => {
        try {
            const today = new Date();
            const entryData = {
                uuid: uuidv4(),
                date: today.toISOString().split('T')[0], // YYYY-MM-DD format
                name,
                surname,
                company,
                time_in: timeIn,
                profile_id: profileId // Will be null for manual entries, user's ID for dropdown selections
            };
            const { status } = await add_register_entry(entryData);
            if (status === 200) {
            fetchFireRegisterData(); // Refresh the data
            this.showAlert({
                message: `${name} ${surname} signed in successfully.`,
                type: 'success',
                buttons: [{ type: 'success', label: 'OK' }],
            });
            } else {
            this.showAlert({
                message: 'Failed to sign in.',
                type: 'danger',
                buttons: [{ type: 'danger', label: 'Close' }],
            });
            }
        } catch (error) {
            this.showAlert({
                message: 'An error occurred while signing in.',
                type: 'danger',
                buttons: [{ type: 'danger', label: 'Close' }],
            });
        }
    }

    handleSignOut = async (entryId, timeOut, fetchFireRegisterData) => {
        try {
            const { status } = await update_register_entry(entryId, { time_out: timeOut });
            if (status === 200) {
                fetchFireRegisterData(); // Refresh the data
                this.showAlert({
                    message: 'Signed out successfully.',
                    type: 'success',
                    buttons: [{ type: 'success', label: 'OK' }],
                });
            } else {
            this.showAlert({
                message: 'Failed to sign out.',
                type: 'danger',
                buttons: [{ type: 'danger', label: 'Close' }],
            });
            }
        } catch (error) {
            this.showAlert({
                message: 'An error occurred while signing out.',
                type: 'danger',
                buttons: [{ type: 'danger', label: 'Close' }],
            });
        }
    }
    // ...other methods...
}